export const constants = {
  SLIDES_FOLDER_PATH: 'upload_slides',
}
